// extracted by mini-css-extract-plugin
export default {"alert":"HPuzozU0OigUwPfwylFP","count":"AUJmsJAIqNL77Z6Aeimj"};